module.exports = __webpack_public_path__ + "static/media/gabi.ee011350.jpg";